var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Card',{staticClass:"w-full"},[_c('template',{slot:"content"},[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("405")]),_c('p',[_vm._v("No tienes permisos para acceder a esta página")])])])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }